import {
  IonIcon,
  IonLoading,
  IonPage,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/react";
import {
  keypadSharp,
  notificationsSharp,
  personSharp,
  swapHorizontal,
} from "ionicons/icons";
import Account from "pages/Account";
import Business from "pages/Account/Business/Business";
import FAQ from "pages/Account/FAQ/FAQ";
import Personal from "pages/Account/Personal/Personal";
import Suggestion from "pages/Account/Suggestion/Suggestion";
import Support from "pages/Account/Support/Support";
import Withdrawals from "pages/Account/Withdrawals/Withdrawals";
import WithdrawalsPage from "pages/Account/Withdrawals/WithdrawalsPage";
import WithdrawScreen from "pages/Account/Withdrawals/WithdrawScreen";
import Register from "pages/Auth/Register";
import Checkout from "pages/Checkout";
import History from "pages/History";
import BTCPaySetup from "pages/LightningServiceProvider/BTCPaySetup";
import LightningServiceProvider from "pages/LightningServiceProvider/LightningServiceProvider";
import LSPList from "pages/LightningServiceProvider/LSPList";
import NoHassleSetup from "pages/LightningServiceProvider/NoHassleSetup";
import Square from "pages/LightningServiceProvider/Square";
import WelcomeToOshi from "pages/LightningServiceProvider/WelcomeToOshi";
import Notifications from "pages/Notifications";
import Transactions from "pages/Transactions";
import { useContext, useEffect } from "react";
import { Route, useHistory } from "react-router";
import { Redirect } from "react-router-dom";
import { ExchangeStore } from "stores/ExchangeStore";
import client from "utils/Api";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import { LOGGED_IN, NOT_LOGGED_IN } from "./constants/AuthStatus";
import { AuthContext } from "./contexts/AuthContext";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import Login from "./pages/Auth/Login";
import "./Tabs.css";

const Tabs = () => {
  const authContext = useContext(AuthContext);
  const { authStatus, authState } = authContext;
  const history = useHistory();

  useEffect(() => {
    if (authStatus === LOGGED_IN)
      history.push("/notifications", { direction: "root" });
    if (
      authStatus === NOT_LOGGED_IN &&
      history.location.pathname !== "/register" &&
      history.location.pathname !== "/login"
    )
      history.push("/login", { direction: "root" });

    async function getRates() {
      const axiosClient = client(authState.token);
      const res = await axiosClient.get("/rates");
      ExchangeStore.update((s) => {
        s.exchangeRate = { ...res.data.rate };
      });
    }

    if (authStatus === LOGGED_IN) {
      getRates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStatus]);

  return (
    <>
      {authState.status === "loading" ? (
        <IonPage>
          <IonLoading />
        </IonPage>
      ) : authStatus === LOGGED_IN ? (
        <IonTabs>
          <IonRouterOutlet id="root-router">
            <PrivateRoute
              exact
              path="/:tab(checkout)/history"
              component={History}
            />
            <PrivateRoute path="/:tab(checkout)" component={Checkout} exact />
            <PrivateRoute
              path="/:tab(transactions)"
              component={Transactions}
              exact
            />
            <PrivateRoute
              path="/:tab(notifications)"
              component={Notifications}
              exact
            />
            <PrivateRoute
              exact
              path="/:tab(account)/withdrawals/withdraw/:type/:id"
              component={WithdrawScreen}
            />
            <PrivateRoute
              exact
              path="/:tab(account)/withdrawals"
              component={Withdrawals}
            />
            <PrivateRoute
              exact
              path="/:tab(account)/withdrawals/all"
              component={WithdrawalsPage}
            />
            <PrivateRoute path="/:tab(account)" component={Account} exact />
            <PrivateRoute
              path="/:tab(account)/suggestion"
              component={Suggestion}
              exact
            />
            <PrivateRoute
              path="/:tab(account)/support"
              component={Support}
              exact
            />
            <PrivateRoute
              path="/:tab(account)/square"
              component={Square}
              exact
            />
            <PrivateRoute
              path="/:tab(account)/lsp/btcpay-setup"
              component={BTCPaySetup}
              exact
            />
            <PrivateRoute
              path="/:tab(account)/lsp/quickstart/:id"
              component={NoHassleSetup}
              exact
            />
            <PrivateRoute
              path="/:tab(account)/welcome"
              component={WelcomeToOshi}
              exact
            />
            <PrivateRoute
              path="/:tab(account)/lsp/select"
              component={LightningServiceProvider}
              exact
            />
            <PrivateRoute path="/:tab(account)/lsp" component={LSPList} exact />
            <PrivateRoute
              path="/:tab(account)/business"
              component={Business}
              exact
            />
            <PrivateRoute path="/:tab(account)/faq" component={FAQ} exact />
            <PrivateRoute
              path="/:tab(account)/personal"
              component={Personal}
              exact
            />
            <Route
              path="/"
              render={() => <Redirect to="/notifications" />}
              exact
            />
          </IonRouterOutlet>
          <IonTabBar slot="bottom">
            <IonTabButton tab="checkout" href="/checkout">
              <IonIcon icon={keypadSharp} />
            </IonTabButton>
            <IonTabButton tab="transactions" href="/transactions">
              <IonIcon icon={swapHorizontal} />
            </IonTabButton>
            <IonTabButton tab="notifications" href="/notifications">
              <IonIcon icon={notificationsSharp} />
            </IonTabButton>
            <IonTabButton tab="account" href="/account">
              <IonIcon icon={personSharp} />
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      ) : (
        <IonRouterOutlet>
          <PublicRoute path="/login" component={Login} exact />
          <PublicRoute path="/register" component={Register} exact />
          <PublicRoute
            path="/forgot-password"
            component={ForgotPassword}
            exact
          />
          <Route path="/" render={() => <Redirect to="/register" />} exact />
        </IonRouterOutlet>
      )}
    </>
  );
};

export default Tabs;
